<template>
  <div class="authlogs-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">AUTH LOGS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search auth logs..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="authColumns"
        :items="authLogs"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ formated_date_time(props.item.logged_in_at) }}</td>
          <td v-if="props.item.logged_out_at !== null">
            {{ formated_date_time(props.item.logged_out_at) }}
          </td>
          <td v-if="props.item.logged_out_at === null">
            <v-icon color="#2196f3" class="status-icon">visibility</v-icon>
          </td>
          <td class="font-weight-medium">{{ props.item.user }}</td>
          <td>{{ props.item.ip_address }}</td>
          <td>{{ props.item.browser }}</td>
          <td class="fancy" v-if="props.item.loggin_status_code === 10">
            <v-icon color="#44bd32" right class="status-icon">check_circle</v-icon>
          </td>
          <td class="fancy" v-if="props.item.loggin_status_code === 100">
            <v-icon color="#ff5252" right class="status-icon">cancel</v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>

      <v-container class="action-buttons">
        <v-btn
          depressed
          @click="getMore()"
          color="#2196f3"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>add</v-icon>
          GET MORE
        </v-btn>
        <v-btn
          depressed
          @click="getAllAuthLogs()"
          color="#9e9e9e"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>list</v-icon>
          GET ALL
        </v-btn>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AuthLogs",
  data() {
    return {
      search: "",
      page: 2,
      authColumns: [
        {
          text: "Logged in at",
          value: "logged_in_at",
          class: "table-header"
        },
        {
          text: "Logged out at",
          value: "logged_out_at",
          class: "table-header"
        },
        {
          text: "User",
          value: "user",
          class: "table-header"
        },
        {
          text: "Source IP",
          value: "ip_address",
          class: "table-header"
        },
        {
          text: "Browser",
          value: "browser",
          class: "table-header"
        },
        {
          text: "Status",
          class: "table-header"
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("get_auth_logs");
  },
  methods: {
    getMore() {
      this.loading = true;
      
      if (this.page === 2) {
        this.$store.dispatch("get_more_auth_logs", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_auth_logs", this.page);
        this.page = this.page + 1;
      }
    },
    getAllAuthLogs() {
      this.loading = true;
      this.page = 0;
      this.$store.dispatch("get_more_auth_logs", this.page);
    },
  }
};
</script>

<style scoped>
.authlogs-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.authlogs-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

.status-icon {
  font-size: 20px;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .authlogs-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .authlogs-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>